import React from "react";
import { observer } from "mobx-react-lite";
import { Alert, Snackbar } from "@mui/material";
import feedbackStore from "../../stores/FeedbackStore";
import useTranslation from "../../hooks/useTranslation";

const Feedback = observer(() => {
  const { t } = useTranslation();

  return (
    <>
      <Snackbar
        action={feedbackStore.feedbackData.action}
        open={feedbackStore.showFeedback}
        anchorOrigin={{
          vertical: feedbackStore.feedbackData.position || "bottom",
          horizontal: "center",
        }}
      >
        <Alert
          severity={feedbackStore.feedbackData?.severity}
          sx={{ width: "100%" }}
          onClose={() => feedbackStore.setShowFeedback(false)}
        >
          <span>{t(feedbackStore.feedbackData?.message)}</span>
        </Alert>
      </Snackbar>
    </>
  );
});

export default Feedback;
